import React, { useState } from 'react';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import { requestApproval } from '../../../../slices/orders.slice';
import { toast } from 'react-toastify';
import OrderModalContent from '../../../../components/OrderModal/OrderModalContent';

const ProposalButtons = ({ order }) => {
    const dispatch = useDispatch();
    const [modal, setModal] = useState({ isOpen: false, action: '' });
    const { user } = useSelector(state => state.auth);

    if (!order) return null;

    const toggleModal = () => setModal(prev => ({ ...prev, isOpen: !prev.isOpen }));

    const openModal = (action) => () => {
        setModal({ isOpen: true, action });
    };

    const handleApproval = (operation) => {
        const promise = dispatch(requestApproval({ orderId: order._id, operation, body: {} })).unwrap();

        toast.promise(promise, {
            pending: 'Updating order',
            success: 'Order updated successfully',
            error: 'Error updating order',
        });

        setModal({ isOpen: false, action: '' });
    };

    const modalTitles = {
        ACCEPT: 'Accept proposal',
        DECLINE: 'Decline proposal',
    };

    return (
        <>
            <Button color="primary" outline onClick={openModal('ACCEPT')}>
                <span className="fas fa-check me-2" />
                Accept
            </Button>
            <span className="px-3" />
            <Button color="danger" outline onClick={openModal('DECLINE')}>
                <span className="fas fa-times me-2" />
                Decline
            </Button>

            {modal.isOpen && (
                <Modal isOpen={modal.isOpen} toggle={toggleModal} size="lg" fullscreen="lg" scrollable>
                    <ModalHeader toggle={toggleModal} tag="div">
                        <div className="text-expand text-uppercase mb-2">
                            {modal.action === 'ACCEPT' ? 'Accept' : 'Decline'} proposal
                        </div>
                        <h3 className="text-uppercase text-primary">{modalTitles[modal.action]}</h3>
                    </ModalHeader>
                    <ModalBody>
                        <OrderModalContent
                            modalType={modal.action}
                            order={order}
                            user={user}
                        />
                    </ModalBody>
                    <ModalFooter>
                        {modal.action === 'ACCEPT' && (
                            <Button color="success" outline onClick={() => handleApproval('approve')}>
                                <span className="fas fa-check-circle me-2" />
                                Accept
                            </Button>
                        )}
                        {modal.action === 'DECLINE' && (
                            <Button color="danger" outline onClick={() => handleApproval('decline')}>
                                <span className="fas fa-times-circle me-2" />
                                Decline
                            </Button>
                        )}
                    </ModalFooter>
                </Modal>
            )}
        </>
    );
};

export default ProposalButtons;
